import { render, staticRenderFns } from "./EmailMessageTemplateSignatureSection.vue?vue&type=template&id=145e9b49&scoped=true"
import script from "./EmailMessageTemplateSignatureSection.vue?vue&type=script&lang=js"
export * from "./EmailMessageTemplateSignatureSection.vue?vue&type=script&lang=js"
import style0 from "./EmailMessageTemplateSignatureSection.vue?vue&type=style&index=0&id=145e9b49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145e9b49",
  null
  
)

export default component.exports